module.exports = __webpack_public_path__ + "static/meda-provider6-9c771aa2c88a1d41886a112b88259f62.png";